import React from 'react'
import { useDispatch } from 'react-redux'
import StarRatingComponent from 'react-star-rating-component'
import { toggleFeedbackOverlay } from 'store/Course/actions'

const Rating = (props) => {
	let color1 = '#E6CF4B'
	let color = '#ffb400'
	const dispatch = useDispatch()
	const { ratings_count, ratings_average } = props.course.courseRatingData
	return (
		<div className='d-flex'>
			<span style={{ marginRight: '10px' }}>Reviews:</span>
			<span className='rating-stars'>
				<StarRatingComponent
					className='user-rating'
					name='rate2'
					starCount={5}
					value={ratings_average}
					starColor={color}
					emptyStarColor={'#bbb3b3'}
					renderStarIcon={(index, value) => (
						<span>
							<i
								// style={{ color: 'red' }}
								className={index <= value ? 'fas fa-star' : 'far fa-star'}
							></i>
						</span>
					)}
					renderStarIconHalf={() => (
						<span>
							<i style={{ color }} className={'fas fa-star-half-alt'}></i>
						</span>
					)}
					editing={false}
				/>
			</span>
			<span
				title={
					ratings_count === 0
						? 'No reviews yet'
						: props.access !== 3
						? 'Reviews List'
						: 'Your review'
				}
				onClick={
					ratings_count !== 0 && props.courseStatus && props.courseStatus === 4
						? () => dispatch(toggleFeedbackOverlay())
						: null
				}
				style={{
					marginLeft: '10px',
					cursor: 'pointer',
					textDecoration: 'underline',
				}}
			>
				({ratings_count})
			</span>
		</div>
	)
}

export default Rating
